import { RouteProp, useRoute } from '@react-navigation/native';
import React, { createContext } from 'react';

import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import { CustomerDetailStackParamList } from '../../../../routes/types';
import { customerDetailCompositionPortfolioQuery } from '../../../../store/customerDetail/selector';
import { FinancialCustomerCompositionChartResponseNormalized } from '../../../../store/customerDetail/types';

type FinancialDetailsContextType = {
  data: FinancialCustomerCompositionChartResponseNormalized | null | undefined;
  loading: boolean;
  error: any;
  refresher: () => void;
};

export const FinancialDetailsContext = createContext<FinancialDetailsContextType>({
  data: undefined,
  loading: false,
  error: undefined,
  refresher: () => {},
});

export const FinancialDetailsProvider = ({ children }: { children: React.ReactNode }) => {
  const routeParams = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();
  const { data, loading, error, refresher } = useRecoilQuery(
    customerDetailCompositionPortfolioQuery({ accountNumber: routeParams.params?.accountNumber })
  );

  return (
    <FinancialDetailsContext.Provider value={{ data, loading, error, refresher }}>
      {children}
    </FinancialDetailsContext.Provider>
  );
};
